module.exports = __webpack_public_path__ + "img/sstv-logo.38ed948f.png";